import { render, staticRenderFns } from "./RelVolunteerEvent.vue?vue&type=template&id=495a6bb0&scoped=true"
import script from "./RelVolunteerEvent.vue?vue&type=script&lang=js"
export * from "./RelVolunteerEvent.vue?vue&type=script&lang=js"
import style0 from "./RelVolunteerEvent.vue?vue&type=style&index=0&id=495a6bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a6bb0",
  null
  
)

export default component.exports